import styled, { keyframes, css } from 'styled-components';

import { useCustomTheme } from '../../styles';


type SwitchSharedProps = {
	isActive: boolean;
	disabled?: boolean;
	withLabels?: boolean;
	withAnimation?: boolean;
}

const switchRightMotion = keyframes`
	0% {
		transform: scale(1, 1) translate(0, 0);
	}

	50% {
		transform: scale(1.4, 1) translate(50%, 0);
	}

	100% {
		transform: scale(1, 1) translate(100%, 0);
	}
`;

const switchLeftMotion = keyframes`
	0% {
		transform: scale(1, 1) translate(100%, 0);
	}

	50% {
		transform: scale(1.4, 1) translate(50%, 0);
	}

	100% {
		transform: scale(1, 1) translate(0, 0);
	}
`;

const Root = styled.div`
	position: relative;
	display: inline-flex;
	flex-flow: column nowrap;
`;

const ContentLayout = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	width: auto;
	height: auto;
`;

const SwitchLayout = styled.div<SwitchSharedProps>`
	position: relative;
	display: inline-flex;
	width: 40px;
	height: 20px;
	border-radius: 10px;
	box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 0 1px 0 rgba(0, 0, 0, 0.05);
  background-color: #e8e8e8;
  border: solid 1px #bdbdbd;
	cursor: pointer;
	transition: background-color .2s ease-in-out, border-color .2s ease-in-out;
	outline: none;

	&:focus .ios-switch-circle {
		box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
	}

	${(p) => p.isActive && `
		background-color: ${useCustomTheme(p)[0].color.accentPrimary};
		border-color: ${useCustomTheme(p)[0].color.accentPrimary};
	`}

	${(p) => p.disabled && `
		background-color: ${p.isActive ? useCustomTheme(p)[0].color.accentPrimaryDisabled : useCustomTheme(p)[0].color.blackStealthy};
		border-color: ${p.isActive ? useCustomTheme(p)[0].color.accentPrimaryDisabled : useCustomTheme(p)[0].color.blackDisabled};

		&:focus .ios-switch-circle {
			box-shadow: none;
		}
	`}

	${(p) => p.withLabels && `
		margin: 0 8px;
	`}
`;

const Circle = styled.div.attrs({
	className: 'ios-switch-circle'
})`
	position: absolute;
	top: -1px;
	left: -1px;
	display: inline-flex;
	width: 20px;
	height: 20px;
	border: solid 1px transparent;
	border-radius: 50%;
	background-image: linear-gradient(to bottom, #fcfcff, #e6e6e6);
	transition: border-color .2s ease-in-out, box-shadow .2s ease-in-out;
	z-index: 1;

	${(p: SwitchSharedProps) => !p.isActive && css`
		border-color: ${useCustomTheme(p)[0].color.blackDisabled};
		transform: translate(0, 0);
		animation: ${switchLeftMotion};
		animation-duration: .2s;
		animation-timing-function: ease-in-out;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	`}

	${(p: SwitchSharedProps) => p.isActive && css`
		transform: translate(100%, 0);
		border-color: ${useCustomTheme(p)[0].color.accentPrimary};
		animation: ${switchRightMotion};
		animation-duration: .2s;
		animation-timing-function: ease-in-out;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	`}
`;

const ChekedIconLayout = styled.div`
	position: absolute;
	top: 50%;
	left: 4px;
	transform: translateY(-50%);
	font-size: 0;
`;

const UnchekedIconLayout = styled.div`
	position: absolute;
	top: 50%;
	right: 4px;
	transform: translateY(-50%);
	font-size: 0;

	& svg {
		fill: #bdbdbd !important;
	}
`;

const Sign = styled.div`
	display: inline-flex;
	font-size: 14px;
	text-decoration: underline;

	${(p: SwitchSharedProps) => `
		color: ${useCustomTheme(p)[0].color.blackDisabled};
	`}

	${(p: SwitchSharedProps) => !p.isActive && `
		text-decoration: none;
		color: ${useCustomTheme(p)[0].color.blackPrimary};
	`}
`;

const LabelLayout = styled.span`
	margin-bottom: 12px;

	& .MuiInputLabel-root {
		position: relative;
	}
`;


export {
	Root,
	ContentLayout,
	SwitchLayout,
	Circle,
	ChekedIconLayout,
	UnchekedIconLayout,
	Sign,
	LabelLayout,
}